import { useReducedMotion } from 'framer-motion';
import { useCallback, useEffect, useRef } from 'react';
import { UNLOCK_SETTLE_MS } from './UnlockPadlock';

/**
 * Runs `settle` once the opening padlock has played, or at once under
 * prefers-reduced-motion. A pending settle is dropped on unmount.
 */
export function useUnlockSettle<T>(settle: (value: T) => void): (value: T) => void {
  const reducedMotion = useReducedMotion();
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    []
  );

  return useCallback(
    (value: T) => {
      if (reducedMotion) {
        settle(value);
        return;
      }
      timer.current = setTimeout(() => settle(value), UNLOCK_SETTLE_MS);
    },
    [reducedMotion, settle]
  );
}
